import { DecimalCategoryFilter, StringCategoryFilter, StringValueIdCategoryFilter } from './filter-backend';
import { PageModel } from './page.model';
import { ProductCategoryFilter } from './product-category-filter.model';

export class TireCategoryFilter implements ProductCategoryFilter {
    paging: PageModel;

    aggressive: boolean;
    aspectRatio: DecimalCategoryFilter;
    aspectRatioRear: DecimalCategoryFilter;
    category: StringValueIdCategoryFilter;
    model: StringCategoryFilter;
    sectionWidth: DecimalCategoryFilter;
    sectionWidthRear: DecimalCategoryFilter;
    specialOrder: boolean;
    studdable: boolean;
    summer: boolean;
    tireBrand: StringCategoryFilter;
    rimDiameter: DecimalCategoryFilter;
    rimDiameterRear: DecimalCategoryFilter;
    tireSize: StringCategoryFilter;
    tireSizeRear: StringCategoryFilter;
}
